import Box from "@mui/material/Box"
import Popover from "@mui/material/Popover"
import Typography from "@mui/material/Typography"
import React from "react"

import { faCircleMinus, faCirclePlus, faClone } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button } from "@mui/material"

type Props = {
    onClone: (count: number) => void
}

const CloneChargers = ({ onClone }: Props) => {
    const [count, setCount] = React.useState(1)
    const [anchorEl, setAnchorEl] = React.useState<SVGSVGElement | null>(null)

    const handleClick = (event: React.MouseEvent<SVGSVGElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleIncrement = () => {
        setCount(count + 1)
    }

    const handleDecrement = () => {
        setCount(count - 1)
    }

    const handleClone = () => {
        onClone(count)
        handleClose()
    }

    const open = Boolean(anchorEl)
    const id = open ? "clone-chargers-popover" : undefined
    return (
        <>
            <FontAwesomeIcon icon={faClone} size="sm" cursor={"pointer"} onClick={handleClick} />
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                slotProps={{
                    paper: {
                        sx: {
                            borderRadius: "12px",
                            padding: "12px",
                        },
                    },
                }}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}>
                <Box
                    display={"flex"}
                    flexDirection={"column"}
                    gap={1}
                    alignItems={"center"}
                    justifyContent={"center"}
                    width={"100%"}>
                    <Typography variant="caption" color="#70758D" fontWeight={500} fontSize={"12px"}>
                        Clone Quantity
                    </Typography>
                    <Box
                        border="0.5px solid#A1A1A1"
                        borderRadius={"14px"}
                        padding={"4px 12px"}
                        display={"flex"}
                        alignItems={"center"}
                        width={"100%"}
                        justifyContent={"space-between"}>
                        <Box
                            width={"16px"}
                            height={"16px"}
                            display={"flex"}
                            alignItems={"center"}
                            justifyContent={"center"}
                            borderRadius={"50%"}
                            bgcolor={"#70758D1A"}
                            sx={{
                                opacity: count === 1 ? 0.5 : 1,
                                cursor: count === 1 ? "not-allowed" : "pointer",
                            }}
                            onClick={count === 1 ? undefined : handleDecrement}>
                            <FontAwesomeIcon icon={faCircleMinus} color="#70758D" />
                        </Box>
                        <input
                            type="text"
                            value={count === 0 ? "" : count}
                            onChange={e => {
                                const value = e.target.value
                                if (value === "") {
                                    setCount(0)
                                } else {
                                    const val = parseInt(value, 10)
                                    if (!isNaN(val) && val >= 0) {
                                        setCount(val)
                                    }
                                }
                            }}
                            onBlur={() => {
                                if (count < 1) setCount(1)
                            }}
                            onKeyDown={e => {
                                if (!/[0-9]|Backspace|Delete|ArrowLeft|ArrowRight|Tab/.test(e.key)) {
                                    e.preventDefault()
                                }
                            }}
                            style={{
                                width: "40px",
                                border: "none",
                                outline: "none",
                                textAlign: "center",
                                fontSize: "16px",
                                fontFamily: "inherit",
                                background: "transparent",
                            }}
                        />
                        <Box
                            width={"16px"}
                            height={"16px"}
                            display={"flex"}
                            alignItems={"center"}
                            justifyContent={"center"}
                            borderRadius={"50%"}
                            bgcolor={"#70758D1A"}
                            sx={{
                                cursor: "pointer",
                            }}
                            onClick={handleIncrement}>
                            <FontAwesomeIcon icon={faCirclePlus} color="#70758D" />
                        </Box>
                    </Box>
                    <Box display={"flex"} gap={1} width={"100%"} mt={1}>
                        <Button
                            variant="text"
                            sx={{
                                fontSize: "11px",
                                color: "#959595",
                                height: "20px",
                            }}
                            onClick={handleClose}
                            fullWidth>
                            Cancel
                        </Button>
                        <Button
                            variant="outlined"
                            color="statiqOrange"
                            sx={{
                                fontSize: "11px",
                                borderRadius: "12px",
                                height: "20px",
                            }}
                            onClick={handleClone}
                            fullWidth>
                            Clone
                        </Button>
                    </Box>
                </Box>
            </Popover>
        </>
    )
}

export default CloneChargers
